import React, { useEffect, useState } from "react";
import MoneyHero from "./common/hero";
import InvestmentOption from "./common/investmentOptions";
import FAQ from "./common/faq";
import { useGetMoneyPageDataQuery } from "../../store/api/moneyApi";
import TaxFilingBanner from "./tax/tax-banner";
import { useNavigate } from "react-router-dom";
import { trackEvent } from "../../analytics";

const header = {
  type: "Invest",
  title: "Talk to your Personal CFO",
  button: "Book Call",
  bgImage: "/assets/money/invest-header-bg.webp",
  image: "/assets/money/invest-header.webp",
  redirectUrl: "https://www.thepersonalcfo.in",
  theme: "#8effc3",
  textColor: "black",
  imageClass: "w-[312px] h-[261px]",
};

const InvestComponent = () => {
  const { data, refetch } = useGetMoneyPageDataQuery("invest");
  const [showTaxBanner, setShowTaxBanner] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    refetch();
  }, []);

  const onClose = () => {
    setShowTaxBanner(false);
  };

  const onClick = () => {
    navigate("/money/protect/tax");
  };
  const isPageViewTracked = React.useRef(false);
  useEffect(() => {
    if (isPageViewTracked.current) return;
    trackEvent("money", {});
    trackEvent("invest_opened", {});
    isPageViewTracked.current = true;
  }, []);
  if (!data) return <></>;
  return (
    <div className="flex flex-col gap-8 max-w-[900px]">
      {showTaxBanner && (
        <TaxFilingBanner onClose={onClose} onKnowMore={onClick} />
      )}
      <MoneyHero
        data={{
          ...header,
          redirectUrl: data?.data?.banner_button?.redirect_url,
        }}
      />
      <InvestmentOption investmentData={data?.data?.fixed_deposits} />
      <FAQ faq={data?.data?.faq} />
    </div>
  );
};

export default InvestComponent;
